const useCommunityDialog = () => {
  const columns = [
    {
      accessorKey: "communityName",
      header: <div>Community Name</div>,
      accessorFn: (row: any) => String(row?.communityName || ""),
    },
  ]

  return {
    columns
  }
}

export default useCommunityDialog;